const ECOMMERCE = {
  ECOMMERCE_PAYMENT_GATEWAYS: '/ecommerce/payment_gateways'
}

export default ECOMMERCE
